import { jsx as _jsx } from "react/jsx-runtime";
import _objectDestructuringEmpty from "/home/prasanta/Projects/get-mutual-transfer-website/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
import React from "react";
import UserDetailsTemplate from "../../../src/components/templates/UserDetailsTemplate/UserDetailsTemplate";
import { makeDetailsTableTemplate, newLoadUserDetails } from "../../../src/hooks/loadUserDetails";
import useUserDetailId from "../../../src/hooks/useUserDetailId";
export default function RailwayStaffUserDetailsRoute(_ref) {
  _objectDestructuringEmpty(_ref);

  var userDetailId = useUserDetailId();

  var _newLoadUserDetails = newLoadUserDetails(userDetailId),
      bodyData = _newLoadUserDetails.bodyData,
      headerInfo = _newLoadUserDetails.headerInfo,
      isLoading = _newLoadUserDetails.isLoading,
      mobileNo = _newLoadUserDetails.mobileNo;

  var _ref2 = headerInfo || {},
      shareInfo = _ref2.shareInfo,
      postedAt = _ref2.postedAt;

  if (!userDetailId.userDetailUserId || isLoading) return /*#__PURE__*/_jsx(UserDetailsTemplate, {
    showShimmer: true,
    detailsKeys: makeDetailsTableTemplate(),
    userInfo: {
      createdDate: "12/05/2021",
      views: "10",
      matched: "0"
    },
    personalInfo: {
      mobileNo: mobileNo
    },
    shareUrl: shareInfo,
    postedAt: postedAt
  });
  return /*#__PURE__*/_jsx(UserDetailsTemplate, {
    postedAt: postedAt,
    showShimmer: isLoading,
    detailsKeys: bodyData,
    userInfo: {
      createdDate: "12/05/2021",
      views: "10",
      matched: "0"
    },
    personalInfo: {
      mobileNo: mobileNo
    },
    shareUrl: shareInfo
  });
}